export default {
  footer: {
    copyright: '© {year} GladKey. All rights reserved.',
    termsOfService: 'Terms of service',
    privacyPolicy: 'Privacy policy',
    contact: 'Contact',
  },
  login: {
    title: 'Welcome back',
    subtitle: 'Log in to access your keys, orders, and wallet',
    emailLabel: 'Email Address',
    emailPlaceholder: "name{'@'}example.com",
    passwordLabel: 'Password',
    forgotPassword: 'Forgot password?',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    submitBusy: 'Signing in…',
    submit: 'Log in',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    verifyRequired: 'Please complete the verification.',
    loginFailed: 'Login failed',
    invalidCredentials: 'Incorrect email or password.',
  },
  validation: {
    emailAndPasswordRequired: 'Please enter your email address and password.',
    emailRequired: 'Please enter your email address.',
    passwordRequired: 'Please enter your password.',
    emailInvalid: 'Please enter a valid email address.',
    emailInvalidPasswordRequired: 'Please enter a valid email address and your password.',
  },
  forgot: {
    title: 'Reset your password',
    subtitle: "Enter your email and we'll send a reset link",
    emailLabel: 'Email Address',
    emailPlaceholder: "name{'@'}example.com",
    submitBusy: 'Sending…',
    submit: 'Send reset link',
    backToLogin: 'Back to login',
    verifyRequired: 'Please complete the verification.',
    sendFailed: 'Could not send reset email',
  },
  sent: {
    title: 'Check your inbox',
    subtitle: "We've sent a reset link to your email",
    openEmailApp: 'Open email app',
    backToLogin: 'Back to login',
  },
  twoFactor: {
    title: 'Two-factor verification',
    subtitleEmail: 'We sent a 6-digit code to your email. Enter it below.',
    subtitleTotp: 'Enter the 6-digit code from your authenticator app.',
    codeLabel: 'Verification code',
    submitBusy: 'Verifying…',
    submit: 'Verify',
    resend: 'Resend code',
    codeSent: 'Code sent ✓',
    backToLogin: 'Back to login',
    codeInvalid: 'Enter the code from your second factor.',
    verifyFailed: 'Invalid or expired code.',
    resendFailed: 'Could not resend the code.',
  },
  register: {
    title: 'Create your account',
    subtitle: 'Join 50,000+ gamers buying keys at fair European prices',
    emailLabel: 'Email Address',
    emailPlaceholder: "you{'@'}example.com",
    passwordLabel: 'Password',
    passwordHint: 'Min 8 characters, must contain at least one letter and one digit',
    passwordConfirmLabel: 'Confirm password',
    passwordMismatch: 'Passwords do not match.',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    agreeTerms: 'I agree to the',
    termsLink: 'Terms & Conditions',
    and: 'and',
    privacyLink: 'Privacy Policy',
    submitBusy: 'Creating…',
    submit: 'Create account',
    alreadyHaveAccount: 'Already have an account?',
    logIn: 'Log in',
    or: 'or',
    termsRequired: 'You must agree to the Terms & Conditions and Privacy Policy.',
    passwordWeak: 'Password must be at least 8 characters and contain a letter and a digit.',
    verifyRequired: 'Please complete the verification.',
    registerFailed: 'Registration failed',
    footerCopyright: '© 2026 GladKey. All rights reserved.',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
    footerCookies: 'Cookie Policy',
  },
  resetPassword: {
    invalidToken: {
      title: 'Link is no longer valid',
      backToLogin: 'Back to login',
      missingToken: 'Missing reset token. Use the link in your reset email.',
      expired: 'This link has expired or is invalid.',
    },
    success: {
      title: 'Password updated',
      subtitle: 'You can now sign in with your new password. Other sessions have been signed out for safety.',
      continueToLogin: 'Continue to login',
    },
    form: {
      title: 'Reset your password',
      subtitle: 'Choose a new password for your account.',
      newPasswordLabel: 'New password',
      confirmLabel: 'Confirm new password',
      passwordHint: 'Min 8 characters, must contain a letter and a digit.',
      passwordWeak: 'Weak',
      passwordOk: 'OK',
      passwordStrong: 'Strong',
      passwordsDontMatch: "Passwords don't match yet.",
      submitBusy: 'Saving…',
      submit: 'Reset password',
      backToLogin: 'Back to login',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      validationWeak: 'Password must be at least 8 characters and contain a letter and a digit.',
      validationMismatch: 'Passwords do not match.',
      verifyRequired: 'Please complete the verification.',
    },
  },
  verifyEmail: {
    verifying: {
      title: 'Verifying your email…',
      subtitle: 'One moment while we confirm the link.',
    },
    success: {
      title: 'Email verified!',
      subtitle: 'Your email is now confirmed. You can purchase items up to €50. For larger purchases, complete KYC in your account.',
      goToDashboard: 'Go to dashboard',
      browseCatalog: 'Browse catalog',
    },
    error: {
      title: 'Verification link expired',
      resend: 'Resend verification email',
      resendSent: 'Verification email sent',
      resendConfirm: 'Verification email sent. Check your inbox.',
      backToLogin: 'Back to login',
      missingToken: 'Missing verification token. The link may have been pasted incorrectly.',
      expired: 'This link has expired or is invalid. Verification links are valid for 24 hours.',
    },
    footerCopyright: '© {year} OG Digital Collective. All rights reserved.',
  },
};
